import { TweenMax } from 'gsap';

class BackToTop {
  constructor() {
    this.dom = {
      button: document.querySelector('.js-back-to-top'),
    };

    this.state = {
      isScrolling: null,
      visible: false
    };

    this.isScrolling = null;
  }

  scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  animate = () => {
    // hide button if it's visible
    if (this.state.visible) {
      TweenMax.fromTo(
        this.dom.button,
        0,
        { autoAlpha: 1 },
        { autoAlpha: 0, css: { pointerEvents: 'none' } }
      );
    }

    // reset state
    this.state.visible = false;

    // clear our timeout throughout the scroll
    window.clearTimeout(this.isScrolling);

    // set a timeout to run after scrolling ends
    this.isScrolling = setTimeout(() => {
      // show button if scrolled more than 1000px
      if (window.pageYOffset > 1000) {
        this.state.visible = true;

        TweenMax.fromTo(
          this.dom.button,
          0.2,
          { autoAlpha: 0 },
          { autoAlpha: 1, css: { pointerEvents: 'all' } }
        );
      }
    }, 600);
  }

  init = () => {
    window.addEventListener('scroll', this.animate, { passive: true });
    this.dom.button.addEventListener('click', this.scrollToTop, { passive: true });
  }
}

export default BackToTop;
